// Odpowiednik Uri.EscapeDataString z .NET: encodeURIComponent dodatkowo koduje znaki !'()*
export function escapeDataString(value) {
    return encodeURIComponent(value).replace(/[!'()*]/g, (c) => "%" + c.charCodeAt(0).toString(16).toUpperCase());
}

// Adres posiedzenia w Portalu Mieszkanca albo null, gdy portal nie jest aktywny,
// posiedzenie nie jest publiczne albo nie znamy jego kodu.
export function getResidentPortalSessionUrl(residentPortal, isPublic, code) {
    if (residentPortal?.isActive !== true) {
        return null;
    }

    const baseAddress = residentPortal.baseAddress;
    if (typeof baseAddress !== "string" || baseAddress.length === 0) {
        return null;
    }

    if (isPublic !== true) {
        return null;
    }

    if (typeof code !== "string" || code.length === 0) {
        return null;
    }

    return `${baseAddress}posiedzenie/${escapeDataString(code)}`;
}
